import { sendGetRequest, sendPostRequest, sendPutRequest } from '@/services/api.service'
import { API_LPE } from '@/config/api.config'

export const userExpress = (clientId, urlParams) => {
  return sendGetRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS}?clientId=${clientId}&search=status:1${urlParams}`
  )
}

export const userExpressCreate = (clientId, data) => {
  return sendPutRequest(`${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS}?clientId=${clientId}`, data)
}

export const currentUserExpress = (userExpressId, clientId, administratorId) => {
  return sendGetRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_ID}?id=${userExpressId}&clientId=${clientId}&administratorId=${administratorId}`
  )
}

export const userExpressUpdate = (userExpressId, clientId, data) => {
  return sendPostRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_ID}?id=${userExpressId}&clientId=${clientId}`,
    data
  )
}

export const campaign = (clientId, urlParams) => {
  return sendGetRequest(`${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN}?clientId=${clientId}${urlParams}`)
}

export const currentCampaign = (campaignId, administratorId, clientId) => {
  return sendGetRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN_ID}?clientId=${clientId}&id=${campaignId}&administratorId=${administratorId}`
  )
}

export const updatecurrentCampaign = (campaignId, clientId, data) => {
  return sendPostRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN_ID}?clientId=${clientId}&id=${campaignId}`,
    data
  )
}

export const campaignCreate = (clientId, data) => {
  return sendPutRequest(`${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN}?clientId=${clientId}`, data)
}

export const campaignsHistory = (administratorId, id) => {
  return sendGetRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN_HISTORY_FULL}?administratorId=${administratorId}&campaignId=${id}`
  )
}

export const campaignHistoryInitialize = (clientId, data) => {
  return sendPutRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN_HISTORY}?clientId=${clientId}&id=0`,
    data
  )
}

export const campaignHistoryUpdate = (administratorId, id, locationId, data) => {
  return sendPostRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN_HISTORY}?administratorId=${administratorId}&locationId=${locationId}&id=${id}`,
    data
  )
}

export const campaignSubmit = (administratorId, action, id, locationId, data) => {
  return sendPostRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.USER_EXPRESS_CAMPAIGN_SUBMIT}?administratorId=${administratorId}&action=${action}&locationId=${locationId}&id=${id}`,
    data
  )
}

export const tmpLocationOpeningHours = locationId => {
  return sendGetRequest(`${API_LPE.BASE_API_URL}${API_LPE.TMP_LOCATION_OPENING_HOURS}?locationId=${locationId}`)
}

export const tmpLocationExceptionalOpeningHours = locationId => {
  return sendGetRequest(
    `${API_LPE.BASE_API_URL}${API_LPE.TMP_LOCATION_EXCEPTIONAL_OPENING_HOURS}?locationId=${locationId}`
  )
}
